export default __webpack_public_path__ + "static/media/prority.7ab67ff0.png";